import type { Workspace } from "@/types/workspace";

import { getMockMarketProfile } from "../market";

import { createId, createPastDate } from "./base";

import { AI_FEATURE } from "@/types/workspace";

/**
 * Generate mock workspaces for an organization
 */
export function generateWorkspaces(
  organizationId: string,
  count: number = 2,
): Workspace[] {
  const workspaces: Workspace[] = [];
  const names = getMockMarketProfile().workspaceNames;

  for (let i = 0; i < count; i++) {
    const createdAt = createPastDate(90 - i * 10);

    workspaces.push({
      id: createId(),
      name: names[i] || `Workspace ${i + 1}`,
      organizationId,
      createdAt,
      updatedAt: createdAt,
      // Top-level on the wire, never inside the config blob.
      workingHours: null,
      offDays: [],
      workingHoursEffectiveFrom: null,
      pendingWorkingHours: null,
      // Mock/dev mode exercises the full AI surface: every feature picked and
      // the workspace switch on, the two halves `useAiEnabled` checks.
      aiFeatures: Object.values(AI_FEATURE),
      config: {
        aiEnabled: true,
        // Echo keeps drafting after a take-over, so the drafting card shows in
        // the mock too.
        aiOnTakeOver: "drafts",
        closingNote: {
          category: "optional",
          summary: "optional",
        },
      },
    });
  }

  return workspaces;
}
